module.exports = __webpack_public_path__ + "static/media/RedData.609de609.svg";